
import Modal from "react-bootstrap/Modal";
import lock from "../../..//assets/images/lock.png";
import { folderService } from "services";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AiFillEye, AiOutlineEyeInvisible } from "react-icons/ai";
import eyeImg from 'assets/images/eye.png';

function SolarFiles(props) {
  const { show, handleClose, id, title, setShowDetailModal, setFolderDetails, setShow } = props;
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, SetErrorMsg] = useState("");

  const verifyPassword = async () => {
    if (!password) {
      SetErrorMsg('Please enter passoword!');
      return;
    }
    const payload = {
      "folderId": id,
      "password": password
    }
    try {
      const response = await folderService.verifyPassword(payload);
      if (response?.data?.success === false) {

        SetErrorMsg(response?.data?.message)
      }
      else {
        setShow(false);
        setShowDetailModal(true);
        setFolderDetails(response?.data?.data);
        toast.success("Folder Verified Successfully");
      }
    }
    catch (err) {
      console.log(err?.response?.data?.message)

    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        verifyPassword();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [password]);

  return (
    <>
      <Modal
        show={show}
        className="modal-common solar-modal"
        onHide={handleClose}
      >
        <Modal.Header closeButton>{title} </Modal.Header>
        <Modal.Body>
          <form>
            <div className="text-center">
              <div className="d-flex justify-content-center align-items-center">
                <img alt="" src={lock} className="mb-4" />
              </div>
              <p >
                Please enter the password shared by pilot to access the folder.{" "}
              </p>
              <div className="my-3 px-4 rounded-3 bg-cyan w-100 d-flex justify-content-between password-input-container" >
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  className="bg-transparent  border-0 focus:outline-0 w-100"
                  onChange={(e) => {
                    setPassword(e.target.value);
                    SetErrorMsg("");
                  }}
                  autoComplete="current-password"
                />
                <h1
                  className="password-toggle-icon cursor-pointer"
                  onClick={togglePasswordVisibility}
                >  {showPassword ? <AiOutlineEyeInvisible size={20} /> : <img src={eyeImg} />}
                </h1>
              </div>
              {errorMsg && <div className="text-danger text-start mb-2 ms-1">{errorMsg}</div>}
              <button type="button" onClick={verifyPassword}
                className="btn text-uppercase d-inline-block btn-primary modal-blue-btn  w-100 text-white"
              >
                Submit
              </button>
              <span>
                If you didn’t receive the password check notification or job
                detail.
              </span>
            </div>

          </form>

        </Modal.Body>
      </Modal>
    </>
  );
}

export default SolarFiles;
